import { LocalStorageKeyEnum } from 'localStorage.enum'

export function isAuthenticated(): boolean {
  if (localStorage.getItem(LocalStorageKeyEnum.USERID)) return true
  return false
}
